import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import LegalNotice from '../../components/LegalNotice';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const MissingProfile = () => {
  const { signOut } = useAuth();

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col justify-between">
      <div className="flex-1 flex flex-col justify-center items-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full bg-white shadow rounded-lg p-8 text-center border border-slate-200">
          <SafeIcon icon={FiIcons.FiAlertTriangle} className="mx-auto h-16 w-16 text-amber-500 mb-4" />
          <h2 className="text-2xl font-bold text-slate-900 mb-2">Account Setup Incomplete</h2>
          <p className="text-slate-600 mb-8">
            Your account setup is incomplete. We could not locate your user profile in the system. Please contact support to resolve this issue.
          </p>
          <button
            onClick={signOut}
            className="w-full flex justify-center py-2 px-4 border border-slate-300 rounded-md shadow-sm text-sm font-medium text-slate-700 bg-white hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-500"
          >
            Sign Out
          </button>
        </div>
      </div>
      <LegalNotice />
    </div>
  );
};

export default MissingProfile;